var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-playground"},[_c('plain-dropdown',{staticClass:"categories",attrs:{"options":_vm.getCategories,"selected":_vm.selected,"on-select":_vm.onSelect,"on-drop-down-change":_vm.onDropdownOpened}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12a9965c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/base-ui-playground/components/PlainDropdownPlayground.vue
// module id = null
// module chunks = 